import { Component, OnInit, Input, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-visor-informe-resolucion',
  templateUrl: './visor-informe-resolucion.component.html',
  styleUrls: ['./visor-informe-resolucion.component.scss']  
})
export class VisorInformeResolucionComponent {

  @Input() pdfSrc;
  @Input() fileName;

  constructor(public activeModal: NgbModal) { }

  descargarPdf() {
    const pdfBlob = new Blob([this.pdfSrc], {type: "application/pdf"});
    this.blobToSaveAs(this.fileName, pdfBlob);
  }

  blobToSaveAs(fileName: string, blob: Blob) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    if (link.download !== undefined) { 
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } 
}